module.exports = __webpack_public_path__ + "img/boat-pic-1.e744807d.jpg";